import i18n from 'i18next'
import Backend from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import { API_URL } from './env'
import { reportMissingTranslation } from 'api/translations'

import { zodI18nMap } from 'zod-i18n-map'
import zodPL from 'zod-i18n-map/locales/pl/zod.json'
import zodEN from 'zod-i18n-map/locales/en/zod.json'
import { z } from 'zod'

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en-GB',
    load: 'currentOnly',
    detection: {
      order: ['queryString', 'localStorage', 'cookie'],
      caches: ['localStorage', 'cookie'],
      lookupCookie: 'connectedlife.i18next',
      lookupLocalStorage: 'connectedlife.i18nextLng',
    },
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: `${API_URL}/v1/translations/{{lng}}.json`,
    },
    saveMissing: true,
    missingKeyHandler: (lngs, ns, key) => {
      if (ns === 'zod') return
      const dotIndex = key.indexOf('.')
      if (dotIndex === -1) return
      const category = key.substring(0, dotIndex)
      const keyCode = key.substring(dotIndex + 1)
      lngs.forEach(languageCode => {
        reportMissingTranslation({ languageCode, category, keyCode })
      })
    },
  })
i18n.addResourceBundle('pl-PL', 'zod', zodPL)
i18n.addResourceBundle('en-GB', 'zod', zodEN)

z.setErrorMap(zodI18nMap)
